import { defineStore } from 'pinia';
import type { Company, Brand, Location } from '@Shared';

export const useCompanyStore = defineStore('company', {
    state: () => ({
        company: null as Company | null,
        brand: null as Brand | null,
        companyLocations: [] as Location[],
        brokerageDetectionEnabled: false,
        /**
         * PLAT-2857 Phase 2: whether this company captures the extra account-validation inputs —
         * the account holder's date of birth (PLAT-3373) and the joint-name notice (PLAT-3133).
         *
         * Defaults to false, and the host does not pass it yet, so the Collect and Confirm forms
         * look exactly as they do today until it is switched on. That default is the point: the
         * date of birth is a REQUIRED field, so shipping it ungated would have added a new blocker
         * to a live participant flow with no way to turn it off.
         */
        accountValidationCaptureEnabled: false,
    }),

    actions: {
        setCompany(newCompany: Company) {
            this.company = newCompany;
        },
        setBrand(newBrand: Brand | null) {
            this.brand = newBrand;
        },
        setBrokerageDetectionEnabled(enabled: boolean) {
            this.brokerageDetectionEnabled = enabled;
        },
        setAccountValidationCaptureEnabled(enabled: boolean) {
            this.accountValidationCaptureEnabled = enabled;
        },
    }
});
